import React, { ChangeEvent, useState } from 'react';
import { useController } from 'react-hook-form';

import styles from './FormDropdown.module.css';
import { DropdownOptions, TooltipObject } from '../../models/formModel';
import Popup from '../popup/popup';

interface FormDropdownProps {
  id: string;
  options: DropdownOptions[];
  placeholder?: string;
  label?: string;
  required?: boolean;
  tooltip?: TooltipObject;
  onChange?: (_: DropdownOptions['value']) => void;
}

const FormDropdown: React.FC<FormDropdownProps> = ({
  id,
  options,
  placeholder = 'Placeholder',
  label = 'label',
  required = false,
  tooltip,
  onChange = () => {},
}) => {
  const {
    field: { onChange: dropdownChanged, value },
  } = useController({ name: id, rules: { required } });

  const [showPopup, setShowPopup] = useState<boolean>(false);

  return (
    <>
      <div className={styles.formDropdownContainer}>
        <div className={'labelContainer'}>
          <div className={required ? 'requiredLabel' : ''}>{label}</div>
          {tooltip && (
            <img
              className={'tooltipIcon'}
              src="/images/info.png"
              alt=""
              onClick={() => setShowPopup(true)}
            />
          )}
        </div>
        <select
          onChange={(e: ChangeEvent<HTMLSelectElement>) => {
            dropdownChanged(e.target.value);
            onChange(e.target.value);
          }}
          value={value}
        >
          <option disabled selected value="">
            {placeholder}
          </option>
          {options.map((opt: DropdownOptions) => {
            return (
              <option value={opt.value} key={opt.value}>
                {opt.label}
              </option>
            );
          })}
        </select>
      </div>

      <Popup
        show={showPopup}
        title={tooltip?.title}
        onButtonClicked={() => setShowPopup(false)}
      >
        {tooltip?.content}
      </Popup>
    </>
  );
};

export default FormDropdown;
